import { FormattedMessage } from 'react-intl';
import Section from './Section';
import { useState } from 'react';
import List from '@/components/List/List';
import { mapConfigToOptions, sortOptions } from '@/lib/listOptions';
import Languages from '@/constants/Languages';
import SearchTextField from '@/components/SearchTextField/SearchTextField';
import { useQuery } from '@tanstack/react-query';
import { fetchFilters } from '@/lib/api';
import FilterOptionsUnavailable from './FilterOptionsUnavailable';

const whiteListedLanguages = ['en', 'es', 'it', 'pt', 'ro'];

const Language = ({
  value,
  onChange,
  mode = 'light',
}: {
  value: string[];
  onChange: (values: string[]) => void;
  mode?: 'light' | 'dark';
}) => {
  const { data, isError } = useQuery({
    queryKey: ['filters'],
    queryFn: fetchFilters,
  });
  const [search, setSearch] = useState('');
  const languageItems = mapConfigToOptions(
    Languages,
    data?.languages
      ?.filter((item) =>
        whiteListedLanguages.includes(item.toLowerCase()),
      )
      .map((item) => ({
        name: item.toLowerCase(),
      })),
  );
  const filteredItems = languageItems.filter((item) =>
    item.text.toString().toLowerCase().includes(search.toLowerCase()),
  );
  const sortedItems = sortOptions(filteredItems);

  return (
    <Section
      title={
        <FormattedMessage id="language" defaultMessage="Language" />
      }
      aria-label="Language filter"
      mode={mode}
      defaultOpen={value.length > 0}
    >
      {isError && !data ? (
        <FilterOptionsUnavailable />
      ) : (
        <>
          <SearchTextField
            value={search}
            onChange={(newV) => setSearch(newV)}
            mode={mode}
            aria-label="Search languages"
          />
          <List
            items={sortedItems}
            values={value}
            onChange={(values) => onChange(values as string[])}
            mode={mode}
          />
        </>
      )}
    </Section>
  );
};

export default Language;
